export default "__VITE_ASSET__dc29bed2__"